<template>
  <component
    :is="moduleId"
    @menuChange="menuChange"
    @itemClick="itemClick"
    @setMainContent="setMainContent"
  ></component>
</template>
<script>
import popHome from "../pop/home";
import partnerHome from "../partner/home";
import brandHome from '../brand/home';
// import czjHome from "../czj/home";
import yuerHome from "../yuer/home";
// import czj2Home from "../czj2/home";
import global from "@/mixins/global";

export default {
  name: "homeIndex",
  data() {
    return {
      moduleId: ""
    };
  },
  mixins: [global],
  mounted() {
    // 1： 联营POP商家 2：全球购商家 3：品牌商家  4：供应商  5：育儿服务  6：成长加 
    const buzzType = this.$cookie.get("buzzType") || "";
    // const paths = ['views/home/pop/home.vue', 'views/home/partner/home.vue']
    // let path = ''
    if (+buzzType === 1 || +buzzType === 2 ) {
      this.moduleId = popHome;
    } else if (+buzzType === 5 || +buzzType === 6 ) {
      this.moduleId = yuerHome; // 育儿和成长加目前是一样的，后期如果不一样在考虑分开
      // 2021.06.08 需求一致，部门统一，合并至一个
    // } else if (buzzType * 1 === 6) {
    //   this.moduleId = czj2Home;
    } else if (+buzzType === 3 ) { // 拆分品牌商和供应商工作台
      this.moduleId = brandHome;
    } else if (+buzzType === 4 || +buzzType === 7 || +buzzType === 11) {
      this.moduleId = partnerHome;
    } else {
      // 不支持的商家类型，直接退出登录
      this.logout()
    }
  },
  methods: {
    setMainContent(component) {
      this.$emit("setMainContent", component);
    },
    itemClick(link) {
      this.$emit("itemClick", link);
    },
    menuChange(item) {
      this.$emit("menuChange", item);
    }
  },
  components: {
    popHome,
    partnerHome,
    brandHome,
    // czjHome,
    yuerHome,
    // czj2Home
  }
};
</script>
